module.exports = __webpack_public_path__ + "685d6a75287ab50af64589bdc6611658.pdf";